import React, { Component } from 'react'
// import BubbleButton from '../BubbleButton/BubbleButton'

import Lines from '../Lines'
import './styles/HowSectionStyles.css'
import firebase from 'firebase'


class HowSection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: '',
            descr: '',
            steps: []
        }
    }

    componentDidMount() {

        const dbRef = firebase.database().ref('sections/HowSection')

        dbRef.on('value', this.setData.bind(this))
    }

    setData(snapshot) {
        const data = snapshot.val()

        if (data) {

            const steps = []

            if (data.steps) {
                for (let key in data.steps) {
                    steps.push(data.steps[key])
                }
            }

            this.setState({
                ...data,
                steps: steps
            })
        }
    }

    render() {

        return (
            <div className="HowSectionWrapper">
                <div className="HowSectionWrapperContent">

                    <div className="HowSectionTitle columns is-mobile">
                        <h2 className="column is-11 is-offset-1">{this.state.title}</h2>
                    </div>
                    <div className="HowSectionDescription columns is-mobile">
                        <p className="column is-5 is-offset-1">{this.state.descr}</p>
                    </div>
                    <div className="TimeLineButtonWrapper ">
                       
                    </div>
                </div>
                <Lines opacity={1}  color={'#9ccdfa'}/>
            </div>
        )
    }
}

export default HowSection


// WEBPACK FOOTER //
// ./src/Components/Sections/HowSection.js